import React, { useEffect, useState } from "react";
import CompareFileVersionHistory from "./CompareFileVersionHistory";
import { Table } from "react-bootstrap";
import Moment from "react-moment";
import { editorProjectServices } from "../../../../APIServices/Editor/editorProjectServices";
import UseToggle from "../../../../Hooks/UseToggle";
import { PageLoader } from "../../../../Components/NoDataFoundTable/NoDataFoundTable";
import { useParams } from "react-router";

const HistoryConsole = ({
  ids,
  theme,
  isFullScreenMode,
  openRightTab,
  isFullScreen,
  setIsFullScreen,
}) => {
  const toggles = UseToggle();
  const [codeVersion, setCodeVersion] = useState([]);
  const [codeVersionLoader, setCodeVersionLoader] = useState(false);
  const { studyId } = useParams();
  const getProjectCodeVersionHistory = async (projectId, uniqueId) => {
    setCodeVersionLoader(true);
    let data = await editorProjectServices.getProjectCodeVersionHistory(
      studyId,
      projectId,
      uniqueId
    );
    setCodeVersion(data?.data || []);
    setCodeVersionLoader(false);
  };
  useEffect(() => {
    if (ids?.projectId && ids?.uniqueId) {
      getProjectCodeVersionHistory(ids?.projectId, ids?.uniqueId);
    }
  }, [ids?.projectId, ids?.uniqueId, openRightTab]);
  return (
    <>
      <div className="overflow-hidden w-100">
        <div
          className="justify-content-between toolbar border-bottom hstack w-100 p-1"
          style={{ height: 35 }}
        >
          <div className="hstack gap-1">
            <i className="fa-solid fa-clock-rotate-left"></i>
            <h6 className="m-0">History</h6>
          </div>
          <div className="hstack gap-1">
            {codeVersion?.length > 0 && (
              <>
                <i
                  title={"Compare Code Version"}
                  className={`fa-solid fa-code-compare CP}`}
                  onClick={toggles.setToggle}
                />
                <div className="vr" />
              </>
            )}
            <i
              title={`${isFullScreen ? "Minimize" : "Maximize"} Console`}
              className={`fa-solid ${
                isFullScreen ? "fa-minimize" : "fa-maximize"
              } CP`}
              onClick={() => setIsFullScreen(!isFullScreen)}
            />
          </div>
        </div>
        <div
          className="p-2"
          style={{
            height: isFullScreenMode
              ? "calc(100vh - 70px)"
              : "calc(100vh - 216px)",
            overflowY: "auto",
          }}
        >
          {codeVersionLoader ? (
            <PageLoader />
          ) : codeVersion?.length > 0 ? (
            <Table
              className="m-0 border-start border-end custom-table"
              bordered
              hover
              striped
            >
              <thead className="position-sticky top-0">
                <tr>
                  <th style={{ width: 60 }}>Version</th>
                  <th>Remark</th>
                  <th>Remark By</th>
                  <th style={{ width: 150 }}>Checked-In Date | Time</th>
                </tr>
              </thead>
              <tbody>
                {codeVersion?.map((item, index) => (
                  <tr key={index}>
                    <td>{`v${item?.version}.0`}</td>
                    <td>{item?.remark}</td>
                    <td>{item?.remarkBy}</td>
                    <td>
                      <Moment format="DD MMM YYYY | HH:mm:ss">
                        {item?.createdAt}
                      </Moment>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          ) : (
            <div className="hstack justify-content-center h-100">
              <div className="px-2 fw-bold fontSize12 text-center">
                <div>No Code Version History Found!</div>
              </div>
            </div>
          )}
        </div>
      </div>
      <CompareFileVersionHistory
        Show={!toggles.toggle}
        Hide={toggles.setToggle}
        Title="Compare Code Version"
        version={codeVersion?.length}
        ids={ids}
        theme={theme}
      />
    </>
  );
};

export default HistoryConsole;
